export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            欢迎漫画作者、内容平台与我们联系合作，共同为漫画爱好者提供更优质的阅读体验
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            {/* Contact Card 1 */}
            <div className="p-6 md:p-7 rounded-2xl bg-background-50 text-center cursor-default">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xl mx-auto mb-4">
                <i className="ri-mail-line"></i>
              </span>
              <h3 className="font-heading font-bold text-sm text-foreground-900 mb-1 whitespace-nowrap">
                商务合作
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                漫画授权、内容合作、广告投放等商务事宜
              </p>
              <p className="text-sm font-medium text-primary-600 mt-2 cursor-pointer hover:text-primary-700 transition-colors whitespace-nowrap">
                business@jiuyao.com
              </p>
            </div>

            {/* Contact Card 2 */}
            <div className="p-6 md:p-7 rounded-2xl bg-background-50 text-center cursor-default">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xl mx-auto mb-4">
                <i className="ri-quill-pen-line"></i>
              </span>
              <h3 className="font-heading font-bold text-sm text-foreground-900 mb-1 whitespace-nowrap">
                作者投稿
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                原创漫画投稿、作品上架申请与创作者支持
              </p>
              <p className="text-sm font-medium text-accent-600 mt-2 cursor-pointer hover:text-accent-700 transition-colors whitespace-nowrap">
                submit@jiuyao.com
              </p>
            </div>

            {/* Contact Card 3 */}
            <div className="p-6 md:p-7 rounded-2xl bg-background-50 text-center cursor-default">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 text-xl mx-auto mb-4">
                <i className="ri-question-answer-line"></i>
              </span>
              <h3 className="font-heading font-bold text-sm text-foreground-900 mb-1 whitespace-nowrap">
                用户反馈
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                意见反馈、问题报告与功能建议
              </p>
              <p className="text-sm font-medium text-secondary-600 mt-2 cursor-pointer hover:text-secondary-700 transition-colors whitespace-nowrap">
                feedback@jiuyao.com
              </p>
            </div>
          </div>

          {/* Social & Community */}
          <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-50 text-center">
            <p className="text-sm text-foreground-600 mb-4">
              也可以通过以下渠道关注九妖漫画网最新动态
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <span className="px-4 py-2 bg-background-200 text-foreground-700 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors">
                <i className="ri-weibo-line mr-1"></i>微博
              </span>
              <span className="px-4 py-2 bg-background-200 text-foreground-700 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors">
                <i className="ri-wechat-line mr-1"></i>微信公众号
              </span>
              <span className="px-4 py-2 bg-background-200 text-foreground-700 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors">
                <i className="ri-bilibili-line mr-1"></i>Bilibili
              </span>
              <span className="px-4 py-2 bg-background-200 text-foreground-700 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors">
                <i className="ri-discord-line mr-1"></i>Discord
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}